import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./AuthDrawer.css";

class ForgotPasswordThree extends Component {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      password1: "",
      password2: "",
    };
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    this
      .props
      .authDrawerActions
      .changePassword(this.props.authDrawer.passwordResetToken, this.props.authDrawer.passwordResetEmail, this.state)
      .then(() => {
        this.changeStep(authDrawerConstants.FORGOTPASSWORD4);
      });
  }

  changeStep(step, event) {
    if (event) {
      event.preventDefault();
    }

    this.props.authDrawerActions.changeStep(step);
  }

  render() {
    return (
      <div className={styles.container}>
        <h3>Resetting password</h3>

        <form onSubmit={this.handleSubmit}>
          <div className={styles.marginTop40}>
            <input onChange={this.handleChange} name="password1" type="password" placeholder="New password" value={this.state.password1} />
          </div>

          <div className={styles.marginTop20}>
            <input onChange={this.handleChange} name="password2" type="password" placeholder="Type it again" value={this.state.password2} />
          </div>

          <div className={styles.nextButton}>
            <button type="submit" className={classNames(styles.blueButton1, styles.block, styles.centered)}>
              Set New Password
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordThree);



// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/ForgotPasswordThree.js